import { useLanguage } from "@digipost/translate";

export function useRootPath(): string {
  const { language } = useLanguage();

  return `/innlogging/${language}`;
}
